<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="enrollments_to_show"
        :fields="fields"
        name="reporte_detalle.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-card>
      <v-card-title>
        Enrollments
        <v-spacer></v-spacer>
        <v-layout row wrap justify-end>
          <v-flex xs3 px-1>
            <v-select
              v-model="status_filter"
              :items="status_items"
              :label="$t('extracurriculares.courses.form.status')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs3 px-1>
            <v-autocomplete
              label="Curso"
              v-model="course_filter"
              :items="courses_to_show"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 px-1>
            <v-autocomplete
              label="Horario"
              v-model="schedule_filter"
              :items="schedules_to_show"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 px-1>
            <v-text-field
              v-model="search_filter"
              append-icon="search"
              :label="$t('extracurriculares.register.search')"
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="enrollments_to_show"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.reserve_date }}</td>
          <td class="text-xs-center">{{ props.item.payment_date }}</td>
          <td class="text-xs-center">{{ props.item.course_name }}</td>
          <td class="text-xs-center">{{ props.item.schedule }}</td>
          <td class="text-xs-center">{{ props.item.student }}</td>
          <td class="text-xs-center">{{ props.item.grade }}</td>
          <td class="text-xs-center">{{ props.item.birth_date }}</td>
          <td class="text-xs-center">{{ props.item.age }}</td>
          <td class="text-xs-center">{{ props.item.student_nit }}</td>
          <td class="text-xs-center">{{ props.item.student_number }}</td>
          <td class="text-xs-center">{{ props.item.family_id }}</td>
          <td class="text-xs-center">{{ props.item.gender }}</td>
          <td class="text-xs-center">{{ props.item.mother_name }}</td>
          <td class="text-xs-center">{{ props.item.mother_phone }}</td>
          <td class="text-xs-center">{{ props.item.mother_email }}</td>
          <td class="text-xs-center">{{ props.item.student_phone }}</td>
          <td class="text-xs-center">{{ props.item.father_name }}</td>
          <td class="text-xs-center">{{ props.item.father_phone }}</td>
          <td class="text-xs-center">{{ props.item.father_email }}</td>
          <td class="text-xs-center">{{ props.item.pay_responsible }}</td>
          <td class="text-xs-center">{{ props.item.sucursal }}</td>
          <td class="text-xs-center">
            <v-btn v-if="showButton(props.item.student_number)" block @click="showAlert(props.item.student_number)" color="accent">{{ $t('reports.headers.alerts') }}</v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="alert_dialog"
      width="450"
      persistent
    >
      <show-alert
        :alert="alert_to_show"
      >
      </show-alert>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="alert_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  import showAlert from './show_alert'
  export default {
    name: 'report-admin-detail',
    components: {
      'download-excel': JsonExcel,
      'show-alert': showAlert,
    },
    data() {
      return {
        headers: [
          { text: this.$t('reports.headers.reserve_date'), align: 'center', value: 'reserve_date' },
          { text: this.$t('reports.headers.payment_date'), align: 'center', value: 'payment_date' },
          { text: this.$t('reports.headers.course'), align: 'center', value: 'course_name' },
          { text: this.$t('reports.headers.schedule'), align: 'center', value: 'schedule' },
          { text: this.$t('reports.headers.student'), align: 'center', value: 'student' },
          { text: this.$t('reports.headers.grade'), align: 'center', value: 'grade' },
          { text: this.$t('reports.headers.birth_date'), align: 'center', value: 'birth_date' },
          { text: this.$t('reports.headers.age'), align: 'center', value: 'age' },
          { text: this.$t('reports.headers.student_nit'), align: 'center', value: 'student_nit' },
          { text: this.$t('reports.headers.student_number'), align: 'center', value: 'student_number' },
          { text: this.$t('reports.headers.family_id'), align: 'center', value: 'family_id' },
          { text: this.$t('reports.headers.gender'), align: 'center', value: 'gender' },
          { text: this.$t('reports.headers.mother_name'), align: 'center', value: 'mother_name' },
          { text: this.$t('reports.headers.mother_phone'), align: 'center', value: 'mother_phone' },
          { text: this.$t('reports.headers.mother_email'), align: 'center', value: 'mother_email' },
          { text: this.$t('reports.headers.student_phone'), align: 'center', value: 'student_phone' },
          { text: this.$t('reports.headers.father_name'), align: 'center', value: 'father_name' },
          { text: this.$t('reports.headers.father_phone'), align: 'center', value: 'father_phone' },
          { text: this.$t('reports.headers.father_email'), align: 'center', value: 'father_email' },
          { text: this.$t('reports.headers.pay_responsible'), align: 'center', value: 'pay_responsible' },
          { text: this.$t('reports.headers.sucursal'), align: 'center', value: 'sucursal' },
          { text: this.$t('reports.headers.alerts'), align: 'center', value: '' },
        ],
        search: '',
        status_filter: '',
        course_filter: '',
        schedule_filter: '',
        search_filter: '',
        loading: false,
        courses: [],
        courses_to_show: [],
        schedules_to_show: [],
        enrollments: [],
        enrollments_to_show: [],
        alerts: [],
        alert_to_show: [],
        alert_dialog: false,
        status_items: [
          { value: 1, text: 'Activo' },
          { value: 0, text: 'Inactivo' },
        ],
        fields: {
          'reserve_date': {
              field: 'reserve_date',
              callback: (value) => {
                return `${value.substr(0,10)}`;
              },
          },
          'payment_date': {
              field: 'payment_date',
              callback: (value) => {
                return `${value.substr(0,10)}`;
              },
          },
          'course': 'course_name',
          'schedule': 'schedule',
          'student': 'student',
          'grade': 'grade',
          'birth_date': 'birth_date',
          'age': 'age',
          'student_nit': 'student_nit',
          'student_number': 'student_number',
          'family_id': 'family_id',
          'gender': 'gender',
          'mother_name': 'mother_name',
          'mother_phone': 'mother_phone',
          'mother_email': 'mother_email',
          'student_phone': 'student_phone',
          'father_name': 'father_name',
          'father_phone': 'father_phone',
          'father_email': 'father_email',
          'pay_responsible': 'pay_responsible',
          'sucursal': 'sucursal',
          'transport': 'transport',
        }
      }
    },
    watch: {
      status_filter() {
        this.filter_enrollments()
      },
      course_filter() {
        this.filter_enrollments()
      },
      schedule_filter() {
        this.filter_enrollments()
      },
      search_filter() {
        this.filter_enrollments()
      },
    },
    created () {
      this.init();
    },
    methods: {
      filter_enrollments() {
        let enrollments_to_show = this.enrollments
        let courses_to_show = this.courses
        let schedules_to_show = []

        if ((this.status_filter || this.status_filter === 0) && this.status_filter !== '') {

          courses_to_show = courses_to_show.filter(course => course.status === this.status_filter)
          enrollments_to_show = enrollments_to_show.filter(enrollment => enrollment.course_status === this.status_filter)
          
          this.courses_to_show = courses_to_show
        }

        if (this.course_filter && this.course_filter !== '') {
          enrollments_to_show = enrollments_to_show.filter(enrollment => enrollment.course_id === this.course_filter)
        }

        if (this.schedule_filter && this.schedule_filter !== '') {
          enrollments_to_show = enrollments_to_show.filter(enrollment => enrollment.schedule === this.schedule_filter)
        }

        if (this.search_filter && this.search_filter.trim() !== '') {
          enrollments_to_show = enrollments_to_show
            .filter(enrollment => enrollment.course_name.toUpperCase().indexOf(this.search_filter.toUpperCase()) > -1)
        }

        this.enrollments_to_show = enrollments_to_show

        this.enrollments_to_show.forEach(enrollment => {
          schedules_to_show.push({
            value: enrollment.schedule,
            text: enrollment.schedule
          })
        });
        console.log(schedules_to_show);

        this.schedules_to_show = schedules_to_show
      },
      init() {
        this.loading = true
        axios.get('/api/extracurriculares/report/admin/detail')
          .then(resp => {
            if (resp.status === 200) {
              resp.data.data.forEach(enrollment => {
                let {
                  reserve_date,
                  payment_date,
                  course_name,
                  course_status,
                  course_id,
                  schedule,
                  student,
                  grade,
                  birth_date,
                  age,
                  student_nit,
                  student_number,
                  family_id,
                  gender,
                  mother_name,
                  mother_phone,
                  mother_email,
                  student_phone,
                  father_name,
                  father_phone,
                  father_email,
                  pay_responsible,
                  sucursal,
                  transport,
                } = enrollment

                this.enrollments.push({
                  reserve_date,
                  payment_date,
                  course_name,
                  course_status,
                  course_id,
                  schedule,
                  student,
                  grade,
                  birth_date,
                  age,
                  student_nit,
                  student_number,
                  family_id,
                  gender,
                  mother_name,
                  mother_phone,
                  mother_email,
                  student_phone,
                  father_name,
                  father_phone,
                  father_email,
                  pay_responsible,
                  sucursal,
                  transport,
                })
                this.schedules_to_show.push({
                  value: schedule,
                  text: schedule
                })
              })
              this.alerts = resp.data.alerts
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
          this.enrollments_to_show = this.enrollments,

        axios.get('/api/extracurriculares/report/assistance/courses')
          .then(resp => {
            if (resp.status === 200) {
              resp.data.forEach(course => {
                this.courses.push({
                  value: course.id,
                  text: course.name,
                  status: course.status
                })
              });
            }
          })
          this.courses_to_show = this.courses
      },
      showAlert(student_number) {
        const alert_to_show = this.alerts
          .find(it => it.studentidentifier == student_number)

        if (alert_to_show !== undefined) {
          this.alert_to_show = alert_to_show
          this.alert_dialog = true
        } else {
          return false
        }
      },
      showButton(student_number) {
        const alert_to_show = this.alerts
          .find(it => it.studentidentifier == student_number)

        if (alert_to_show !== undefined) {
          return true
        } else {
          return false
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/reports/admin_detail.vue